import { api } from '@/lib/api-client'
import type { ActivityEntry, DashboardStats } from '@/types/api'

export function fetchDashboardStats(trendDays = 14): Promise<DashboardStats> {
  return api.get<DashboardStats>('/api/admin/stats', { query: { trendDays } })
}

export function fetchRecentActivity(limit = 10): Promise<ActivityEntry[]> {
  return api.get<ActivityEntry[]>('/api/admin/activity', { query: { limit } })
}
